import CompressionBookingItem from 'components/molecules/CompressionBookingItem';
import { useTranslation } from 'react-i18next';
import { TCompressionBooking } from 'types/compression';
import { mergeClasses } from 'util/commons';
import styles from './CompressionBooking.module.scss';

type CompressionBookingProps = {
  compressions: TCompressionBooking[];
  isStorage?: boolean;
};

const CompressionBooking = ({
  compressions,
  isStorage,
}: CompressionBookingProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.bookingContainer}>
      <div className={styles.heading}>
        <div
          className={mergeClasses(
            styles.headingItem,
            styles.w65,
            styles.textLeft
          )}
        >
          {t('compressions.content')}
        </div>
        <div className={mergeClasses(styles.headingItem, styles.w35)}>
          {t('compressions.qr')}
        </div>
      </div>
      <div className={styles.items}>
        {compressions.length === 0 ? (
          <div className={styles.noData}>{t('messages.M_008')}</div>
        ) : (
          compressions.map((compression, index) => (
            <CompressionBookingItem
              compression={compression}
              key={index}
              isStorage={isStorage}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default CompressionBooking;
